import { Queue } from '../utils/Queue'

const FIVE_SECONDS = 5_000

const defaultOptions = {
  delay: FIVE_SECONDS,
}

export class TrackConsentQueue<Consent> {
  private queue: Queue<Consent>
  private delay: number

  constructor(
    queue: Queue<Consent>,
    options: { delay: number } = defaultOptions,
  ) {
    this.queue = queue
    this.delay = options.delay
  }

  private scheduleDrain() {
    setTimeout(async () => {
      await this.queue.drain()
    }, this.delay)
  }

  public onChange(storedConsent: Consent) {
    this.queue.enqueue(storedConsent)
    this.scheduleDrain()
  }

  // Alias for onChange
  public onFirstAction(storedConsent: Consent) {
    return this.onChange(storedConsent)
  }

  public onAccept(_: Consent) {
    this.scheduleDrain()
  }
}
